// extracted by mini-css-extract-plugin
export default {"main":"cf274529b4","tit":"_858725733a","maintitle":"_26e7407a34","ylw":"_5929525695","white":"_99e712611e","mv_title":"_6f188c34c2","mv_nc":"_02ac214f60","mv_in":"_920930599f"};